<div class="modal-header">
  <div>
    <h4 class="modal-title">{{ title | translate }}</h4>
    <h5 class="m-b-0 m-t-10"> {{ companyName }} </h5>
  </div>
  <button type="button" class="btn-close" (click)="closeModal()"></button>
</div>
<div class="modal-body">
  <div *ngFor="let feature of features">
    <div class="media m-t-10" style="align-items: center;">
      <label class="label">
        <b>{{ "availableFeatures." + feature.featureName.toLowerCase() | translate }}</b>
      </label>
      <div class="media-body text-end icon-state">
        <label class="switch icon-state">
          <input class="mode" type="checkbox" [checked]="feature.enable"
            (change)="toggleFeature(feature)" /><span class="switch-state"> </span>
        </label>
      </div>
    </div>
    <div class="input-group" *ngIf="feature.enable && feature.startDate">
      <span class="col-form-label label">
        {{ "campaignDetails.startDate" | translate }}
      </span>
      <div class="input-group date" id="sdt-date" data-target-input="nearest">
        <input 
          #startDate
          class="form-control datetimepicker-input digits"
          type="text"
          [value]="feature.startDate"
          [owlDateTime]="sdt"
          readonly
          placeholder="yyyy-mm-dd"
          [id]="'start-date-'+feature.featureName"
          (change)="setStartDate(feature, startDate.value)"
          [min]="today"
          [max]="feature.endDate"
        />
        <div class="input-group-text bg-primary" data-target="#sdt-date" [owlDateTimeTrigger]="sdt">
          <i class="icofont icofont-ui-calendar" style="color: white; font-size: 12px;"></i>
        </div>
      </div>
      <owl-date-time [pickerType]="'calendar'" #sdt></owl-date-time>
    </div>

    <div class="input-group" *ngIf="feature.enable && feature.endDate">
      <span class="col-form-label label">
        {{ "campaignDetails.endDate" | translate }}
      </span>
      <div class="input-group date" id="edt-date" data-target-input="nearest">
        <input 
          #endDate
          class="form-control datetimepicker-input digits"
          type="text"
          [value]="feature.endDate"
          [owlDateTime]="edt"
          placeholder="yyyy-mm-dd"
          [id]="'end-date-'+feature.featureName"
          (dateTimeChange)="setEndDate(feature, endDate.value)"
          [min]="feature.startDate ?? today"
        />
        <div class="input-group-text bg-primary" data-target="#edt-date" [owlDateTimeTrigger]="edt">
          <i class="icofont icofont-ui-calendar" style="color: white; font-size: 12px;"></i>
        </div>
      </div>
      <owl-date-time [pickerType]="'calendar'" #edt></owl-date-time>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="closeModal()">
    {{ "buttons.close" | translate }}
  </button>
  <button class="btn btn-primary" (click)="updateFeatures()">
    {{ "buttons.apply" | translate }}
  </button>
</div>
